import React from 'react'

const PlayWithCircle = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="11.5" stroke="#0D1536" strokeOpacity="0.4"/>
        <path d="M17.8036 12.7353L8.94574 17.8274C8.23935 18.2336 7.66666 17.8985 7.66666 17.079V6.921C7.66666 6.10153 8.23935 5.76643 8.94574 6.17264L17.8036 11.2647C18.5099 11.6707 18.5099 12.3293 17.8036 12.7353Z" fill="#0D1536" fillOpacity="0.4"/>
    </svg>
)

export default PlayWithCircle
